<template>
  <span>
    <Search></Search>
    <v-container fluid>
      <v-flex class="text-xs-center" v-if="Object.keys(missings).length === 0">لا يوجد بيانات</v-flex>
      <v-layout v-else row wrap>
        <v-flex v-for="missing in missings" :key="missing.id" xs12 lg4>
          <missing-card :missing="missing"></missing-card>
        </v-flex>
        <v-flex xs12>
          <div class="text-sm-center mt-5 mb-5">
            <v-pagination :value="pageNumber" @input="updatePage" :length="pages"></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </span>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Search from "../components/missings/Search";
import MissingCard from "../components/missings/MissingCard";

export default {
  data() {
    return {
      page: 1
    };
  },
  components: {
    Search,
    MissingCard
  },
  computed: {
    ...mapState({
      missings: state => state.MissingStore.missings,
      totalCount: state => state.MissingStore.totalCount,
      pageNumber: state => state.MissingStore.pageNumber,
      pageSize: state => state.MissingStore.pageSize
    }),
    pages() {
      if (this.totalCount === 0) return 0;
      return parseInt(this.totalCount / this.pageSize) + 1;
    }
  },
  methods: {
    ...mapActions(["getMissings"]),
    updatePage(pageNumber) {
      this.getMissings(pageNumber);
    }
  }
};
</script>

<style scoped>
</style>